export default function NoCitySelected() {
  return (
    <div>
      <div className="text-center">
        <h3 className="my-3">No City Selected!</h3>
        <p>Please select a city first to see this page.</p>
      </div>
    </div>
  );
}
